export default __webpack_public_path__ + "static/media/deliberatereprisal.6b92ba5c.png";